import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { Button, Input, Title } from '../../components/shared';
import { translate } from '../../lib/lang.helper';
import defaultLogo from '../../images/mussel-app.png';
import { selectAccountBrand } from '../../store/auth/auth.selector';
import { sendSingleRequest } from '../../apis';
import { showFeedback } from '../../store/ui/ui.actions';
import { authLoadMe } from '../../store/auth/auth.actions';

const AccountBrand = () => {
  const dispatch = useDispatch<any>();
  const lang = useSelector(selectLang);
  const account = useSelector(selectAccountBrand);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const [logoFile, setLogoFile] = useState<string>(
    account?.logo ?? defaultLogo,
  );
  const [brandName, setBrandName] = useState<string | null>(
    account?.name ?? null,
  );
  const [disabled, setDisabled] = useState(false);

  const updateLogo = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64 = reader.result as string;
      setLogoFile(base64);
    };

    reader.readAsDataURL(file);
  };
  const selectClick = () => {
    fileInputRef.current?.click();
  };
  const submitForm = async () => {
    const logo =
      logoFile === defaultLogo || logoFile === account?.logo
        ? undefined
        : logoFile;

    setDisabled(true);
    const response = await sendSingleRequest(
      { name: brandName, logo },
      'POST',
      'api/account/brand',
      true,
    );
    if (!response.status) {
      dispatch(
        showFeedback({
          isMessage: true,
          type: 'error',
          message: response.data?.message ?? 'Unknown error',
        }),
      );
    } else {
      await dispatch(authLoadMe(true));
    }
    setDisabled(false);
  };

  return (
    <div className='pb-32 mt-32 pt-16' style={{ borderTop: '2px solid #ccc' }}>
      <div className='mb-24'>
        <Title size={5} color='black-3' align='default' fontWeight={600}>
          {translate(lang, 'Brand')}
        </Title>
      </div>
      <div className='mb-17 d-flex align-center'>
        <img
          src={logoFile}
          alt='Logo Preview'
          style={{
            width: '350px',
            height: '100px',
            objectFit: 'contain',
            border: '1px solid #ccc',
          }}
        />
        <br />
        <Button
          className='ml-24'
          type='bordered'
          color='blue'
          size={0}
          width='small'
          onClick={selectClick}
        >
          {translate(lang, 'Select')}
        </Button>
        <input
          type='file'
          accept='image/*'
          ref={fileInputRef}
          onChange={updateLogo}
          style={{ display: 'none' }}
        />
      </div>
      <div className='mb-17'>
        <Input
          label={translate(lang, 'Brand name')}
          type='text'
          onChange={e =>
            setBrandName(e.target.value.length > 0 ? e.target.value : null)
          }
          value={brandName ?? ''}
          max={50}
        />
      </div>
      <Button
        color='blue'
        size={1}
        width={'wide'}
        type='fill'
        disabled={disabled}
        onClick={submitForm}
      >
        <span>{translate(lang, 'Save')}</span>
      </Button>
    </div>
  );
};

export default AccountBrand;
